import { useT } from "../i18n/LocaleProvider";
import { translateLabel } from "../i18n/translate";
import { statusChip, type Tone } from "./tone";

// ---------------------------------------------------------------------------
// The ONLY way a status reaches the screen.
//
// It takes a tone and words. It does not take a colour, an icon, or a class,
// and that is the design: every affordance for rendering a status wrong has
// been removed rather than documented.
//
// The glyph is aria-hidden and the words are the accessible name. That is the
// right way round — a screen reader announcing "warning triangle, Expiring"
// says the same thing twice, and the second time in the design system's
// vocabulary rather than the user's.
// ---------------------------------------------------------------------------

export function StatusChip({
  tone,
  label,
}: {
  tone: Tone;
  /** Required. `statusChip` throws on an empty one — see tone.ts. */
  label: string;
}) {
  const { locale } = useT();
  const chip = statusChip(tone, label, (text) => translateLabel(locale, text));
  return (
    <span className={chip.className}>
      <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
        <path d={chip.glyph} fillRule="evenodd" />
      </svg>
      {chip.label}
    </span>
  );
}
